if (document.querySelector('.block-trailers-listing')) {
  const clearTaxes = document.querySelector('.prime-clear-taxes');
  const searchInput = document.querySelector('.prime-search-tax input');

  clearTaxes.addEventListener('click', function () {
    document.querySelectorAll('.prime-filter-tax select').forEach((select) => {
      const url = new URL(window.location);

      select.value = 'all';
      searchInput.value = '';
      $('select').niceSelect('update');

      url.search = ''; // remove params
      window.history.pushState({}, '', url); // update url
    });
  });

  let currentPage = 1;
  let maxPages = 1;

  const $container = $('#primeTrailers');
  const $loadMore = $('#load-more');
  const $clearBtn = $('#clearFilters');
  const $selects = $('.prime-filter-tax select');
  const $searchInp = $('.prime-search-tax input');
  const $inStock = $('#inStock');

  const params = new URL(window.location).searchParams;

  if ([...params.keys()].length > 0) {
    $selects.each(function () {
      const name = $(this).attr('name') || $(this).attr('id');
      if (!name) return;
      const value = params.get(name);
      if (value) $(this).val(value);
    });

    if ($.fn.niceSelect) $selects.niceSelect('update');

    if (params.get('search')) {
      $searchInp.val(params.get('search'));
    }
    loadPosts(1, collectFilters());
  }

  function loadPosts(page = 1, options = {}) {
    document.querySelector('.prime-loader').classList.add('active');
    const data = {
      action: 'load_more_trailers',
      page: page,

      brand: $('#brandTax').val() || null,
      color: $('#colorTax').val() || null,
      features: $('#featuresTax').val() || null,
      size: $('#sizeTax').val() || null,
      type: $('#typeTax').val() || null,
      year: $('#yearTax').val() || null,
      search: $('#prime-tax-search').val() || null,
      instock: $('#inStock').is(':checked') ? 1 : 0,
    };

    $loadMore.prop('disabled', true).text('Loading...');

    $.ajax({
      url: prime_ajaxur,
      method: 'POST',
      dataType: 'json',
      data: data,
    })
      .done(function (response) {
        if (response.success && response.data && response.data.html) {
          setTimeout(function () {
            document.querySelector('.prime-loader').classList.remove('active');
          }, 300);
          maxPages = response.data.max || 1;

          if (page === 1) {
            $container.html(response.data.html);
          } else {
            $container.append(response.data.html);
          }

          currentPage = page;

          if (currentPage >= maxPages) {
            $loadMore.hide();
          } else {
            $loadMore.show().prop('disabled', false).text('Load More');
          }
        } else {
          // нет данных
          setTimeout(function () {
            document.querySelector('.prime-loader').classList.remove('active');
          }, 300);
          if (page === 1) $container.html('<p>No trailers...</p>');
          $loadMore.hide();
        }
      })
      .fail(function () {
        console.error('AJAX error при загрузке постов');
        $loadMore.text('Ошибка загрузки').prop('disabled', false);
      });
  }

  // ------- Load More -------
  $loadMore.on('click', function () {
    const next = currentPage + 1;
    const filters = collectFilters();
    loadPosts(next, filters);
  });

  // ------- Get filters-------
  function collectFilters() {
    const out = {};
    $selects.each(function () {
      const name = $(this).attr('name') || $(this).attr('id');

      if (!name) return;
      const val = $(this).val();
      if (val != 'all') out[name] = val;
    });

    const $check = $('#inStock'); // ← твой чекбокс
    if ($check.length && $check.is(':checked')) {
      out.instock = 1;
    }

    const search = $searchInp.length ? $searchInp.val().trim() : '';
    if (search) out.search = search;

    return out;
  }

  function updateUrl(filters = {}) {
    const url = new URL(window.location);
    url.search = '';
    Object.keys(filters).forEach((k) => {
      if (filters[k]) url.searchParams.set(k, filters[k]);
    });
    window.history.pushState({}, '', url);
  }

  // ------- Nice select updated -------
  $selects.on('change', function () {
    $searchInp.val('');
    const filters = collectFilters();
    updateUrl(filters);
    loadPosts(1, filters);
  });
  $inStock.on('change', function () {
    $searchInp.val('');
    const filters = collectFilters();
    updateUrl(filters);
    loadPosts(1, filters);
  });

  // ------- Search (input) -------
  if ($searchInp.length) {
    let timer;
    $searchInp.on('input', function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const searchVal = $searchInp.val().trim();

        if (searchVal !== '') {
          $selects.each(function () {
            this.selectedIndex = 0;
          });
          if ($.fn.niceSelect) $selects.niceSelect('update');

          loadPosts(1, { search: searchVal });
          const url = new URL(window.location);
          url.search = 'search=' + encodeURIComponent(searchVal);
          window.history.pushState({}, '', url);
        } else {
          const filters = collectFilters();
          loadPosts(1, filters);
          updateUrl(filters);
        }
      }, 500); // debounce 500ms
    });
  }
  $clearBtn.on('click', function () {
    $selects.each(function () {
      this.selectedIndex = 0;
    });

    if ($.fn.niceSelect) {
      $selects.niceSelect('update');
    }
    if ($searchInp.length) $searchInp.val('');
    const url = new URL(window.location);
    url.search = '';
    window.history.pushState({}, '', url);
    $('#inStock').prop('checked', false);

    loadPosts(1, {});
  });
}
